module.exports = __webpack_public_path__ + "img/ring_y_c_null_1@2x.06ffbed5.png";